import { PropTypes } from 'prop-types';
import React from 'react';
import { PortalButton } from '@custom-components';
import { ToDoCard } from './ToDo.styles';

function ToDoItem(props) {
  const { itemTitle, itemSubTitle, action } = props;
  return (
    <ToDoCard>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div>
          <span>{itemTitle}</span>
          <br />
          <span style={{ fontSize: '0.75em' }}>{itemSubTitle}</span>
        </div>
      </div>
      {action && (
        <div>
          <PortalButton onClick={action}>GO</PortalButton>
        </div>
      )}
    </ToDoCard>
  );
}

ToDoItem.propTypes = {
  itemTitle: PropTypes.string.isRequired,
  itemSubTitle: PropTypes.string.isRequired,
  action: PropTypes.func
};

ToDoItem.defaultProps = {
  action: null
};

export default ToDoItem;
